import * as types from './mutation-types'
import { StorageService } from '@/services/StorageService'

export default {
    [types.LOGIN] (state, payload) {
        state.auth.token = payload.token
        // Store JWT token in localStorage
        const tokenToStore = payload.access || payload.token
        StorageService.setAuthToken(tokenToStore)
    },
    [types.LOGOUT] (state, payload) {
        state.auth.token = payload.token
        // Clear JWT token from localStorage
        StorageService.clearAuthToken()
        StorageService.clearAllSessionData()
    }
}